import axios from "../../axios"

const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer "+ token
    }
  }
}

export default {
  async getProducts(tenantName, token, erpId, search = null, page = 1, limit = 4) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/products';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName,
          erpId: erpId,
          search: search,
          page: page,
          limit: limit
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
  async updateProductErpInfos(tenantName, token, integrationId, erpId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/products/update-product-erp-infos';
    try {
      return await axios.post('', {
        tenantName: tenantName,
        erpId: erpId,
        integrationId: integrationId,
      }, { ...header(token) });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
}